import { createAsyncThunk } from '@reduxjs/toolkit';
import { denormalisedResponseEntities } from '../util/data';
import { storableError } from '../util/errors';
import { setCurrentUser } from './user.duck';

// ─── Thunk ───

export const toggleFavorite = createAsyncThunk(
  'favorites/toggle',
  (listingId, { getState, dispatch, rejectWithValue, extra: sdk }) => {
    const currentUser = getState().user?.currentUser;
    const privateData = currentUser?.attributes?.profile?.privateData || {};
    const currentFavorites = privateData.favorites || [];

    const isFavorited = currentFavorites.includes(listingId);
    const updatedFavorites = isFavorited
      ? currentFavorites.filter(id => id !== listingId)
      : [...currentFavorites, listingId];

    return sdk.currentUser
      .updateProfile(
        { privateData: { favorites: updatedFavorites } },
        { expand: true }
      )
      .then(response => {
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in updateProfile response');
        }
        dispatch(setCurrentUser(entities[0]));
        return { listingId, isFavorited: !isFavorited };
      })
      .catch(e => rejectWithValue(storableError(e)));
  }
);

// ─── Selectors ───

export const selectFavorites = state =>
  state.user?.currentUser?.attributes?.profile?.privateData?.favorites || [];

export const selectIsFavorited = (state, listingId) =>
  selectFavorites(state).includes(listingId);
